import StyledLoader from 'components/Elements/StyledLoader'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import axiosClient from 'services/axios-client'
import { ForgotPasswordContainer } from './style'

function ForgotPassword() {
  const history = useHistory()
  const { t } = useTranslation()
  const [email, setEmail] = useState('')
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)

  const validated = () => {
    const emailReg =
      /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i

    if (!email || email.trim().length === 0 || !emailReg.test(email)) {
      setError(t('email_must_valid'))
      return false
    }

    return true
  }

  const forgotPasswordHandler = async () => {
    setError(null)
    if (validated()) {
      setLoading(true)
      try {
        const res = await axiosClient.post('/forgot-password', { email })
        if (res.ok) {
          history.push('/forgotpasswordverification')
        }
        setLoading(false)
      } catch (err) {
        setLoading(false)
        console.log(err)
        setError(err.message)
      }
    }
  }

  if (loading) {
    return <StyledLoader />
  }

  return (
    <ForgotPasswordContainer>
      <div className="wrapper">
        <h4>{t('forgot_your_passowrd?')}</h4>
        <h6>{t('forgot_password_narration')}</h6>
        <div>
          <input
            type="email"
            className="input"
            id="email"
            aria-describedby="emailHelp"
            placeholder={t('enter_email')}
            value={email}
            onChange={(evt) => setEmail(evt.target.value)}
          />
          {error && <span className="error">{error}</span>}
          <button className="btn btn-submit" onClick={forgotPasswordHandler}>
            {t('submit')}
          </button>
        </div>
      </div>
    </ForgotPasswordContainer>
  )
}

export default ForgotPassword
